import $ from 'jquery';
import bootbox from 'bootbox';
import 'jquery-validation';
import '../../../vendor/jquery.bootstrap.wizard';
import '../../vendor/spin';
import {translator} from '../../localization/translator';
import '../../jquery/initializers/formToggle';
import '../../jquery/initializers/phone';
import '../../jquery/initializers/select2';

$(document).ready(async () => {
    const $wizard = $('#signup-wizard');

    if ($wizard.length === 0) {
        return;
    }

    // Dynamically import intlTelInput.
    await import('../../vendor/intlTelInput');

    // noinspection JSUnresolvedFunction,JSUnresolvedVariable
    $.extend($.fn.phone.defaults, {hiddenSubmit: false});

    // Add tel validator to jquery-validation.
    $.validator.addMethod('tel', (value, element) => $(element).intlTelInput('isValidNumber'), 'Please enter a valid phone number.');

    const $form = $('form');

    // Prevent Twitter Bootstrap Wizard from adding # to the URL
    $('.wizard li a').on('click', e => e.preventDefault());

    const startLoading = () => {
        const $loading = $('<div id="loading"></div>');
        $wizard.append($loading);
        $loading.spin('large');
    };

    const stopLoading = () => {
        const $loading = $('#loading');
        $loading.spin(false);
        $loading.remove();
    };

    // noinspection JSUnusedGlobalSymbols
    const validator = $form.validate({
        ignoreTitle: true,
        errorPlacement(error, element) {
            element.closest('.form-group').append(error);
        },
        highlight(element) {
            $(element)
                .closest('.form-group')
                .addClass('has-error')
                .removeClass('has-success');
        },
        unhighlight(element) {
            $(element)
                .closest('.form-group')
                .addClass('has-success')
                .removeClass('has-error');
        },
        submitHandler() {
            startLoading();

            const type = $form.attr('method');
            const url = $form.attr('action');
            const fields = $form.serializeArray();

            for (const field of fields) {
                if (field.name === 'manager_signup[mobile]') {
                    field.value = $('#manager_signup_mobile').intlTelInput('getNumber');
                    break;
                }
            }

            // noinspection JSUnresolvedFunction
            const data = $.param(fields);

            const xhr = $.ajax({
                type: type,
                url: url,
                data: data,
            });

            xhr.done(response => {
                if (response.success) {
                    window.location.href = response.target;
                } else {
                    let errors = response.errors.map(error => `<li>${error}</li>`).join('');

                    if(!errors){
                        errors = translator.translate('security.flash.confirm_signup.generic')
                    }

                    const html = `
                        <p class="text-danger">
                            <strong>${translator.translate(`ui.alert.danger.prefix`)}</strong>
                            ${(translator.translate('signup.text.form_errors'))}:
                        </p>
                        <ul class="text-danger">${errors}</ul>
                    `;

                    // noinspection JSUnresolvedFunction
                    bootbox.alert(html);
                }
            });

            xhr.fail(() => {
                const html = `<p class="text-warning"><strong>${translator.translate(`ui.alert.warning.prefix`)}</strong> ${(translator.translate('signup.text.submission_error'))}</p>`;

                // noinspection JSUnresolvedFunction
                bootbox.alert(html);
            });

            xhr.always(() => stopLoading());
        },
    });

    let maxValidIndex = 1;

    const updateMaxValidIndex = newIndex => {
        if (newIndex > maxValidIndex) {
            maxValidIndex = newIndex;
        }
    };

    $wizard.bootstrapWizard({
        onTabClick(activeTab, navigation, currentIndex, clickedIndex) {
            if (clickedIndex < currentIndex) {
                return true;
            }

            if (!validator.form()) {
                return false;
            }

            updateMaxValidIndex(clickedIndex);

            return true;
        },
        onTabShow(activeTab, $navigation, currentIndex) {
            updateMaxValidIndex(currentIndex);

            if (currentIndex === 1) {
                const $stepText = $('#organization-tab').find('.wizard-step-text');

                const organization = $('#manager_signup_customer_name').val();
                if (organization) {
                    $stepText.text(translator.translate('signup.text.organization_custom', {organization}));
                } else {
                    $stepText.text(translator.translate('signup.text.organization'));
                }
            } else if (currentIndex === 2) {
                const $billingEmail = $('#manager_signup_billingProfile_billingEmail');

                if (!$billingEmail.val()) {
                    const email = $('#manager_signup_account_email').val();
                    $billingEmail.val(email);
                }
            }
        },
        onNext() {
            return validator.form();
        },
        onFinish() {
            if (validator.form()) {
                $form.submit();
            }
        },
    });
});
